/**
 * La anestesia de una intervención, tal como la decide el servidor
 * (services/anestesia_de_la_intervencion; 23/9/2026, DECISIÓN D3 de dirección:
 * «chalazión: solo cirugía menor; en todo caso sedación, nunca general»).
 *
 * Diseño cerrado: POR DEFECTO TODA INTERVENCIÓN LLEVA ANESTESIA. No la lleva
 * si un médico la marca «Anestesia local, sin anestesista» en el parte y esa
 * marca sigue valiendo, o si el registro quirúrgico dice «¿Con sedación?» No
 * (administración, 8/10/2026; solo gana a eso «Lleva anestesista»). La
 * pantalla recibe la respuesta (`lleva_anestesia`, y `anestesia.sin_sedacion`)
 * y aquí solo se aplica; no se lee ningún texto. Mientras el servidor no diga
 * que NO (`!== false`), lleva.
 */

function vacio(v) {
  return !v || (typeof v === 'string' && !v.trim());
}

/**
 * ¿Este CI de anestesia NO se le pide a la paciente? Solo el que está en
 * blanco (sin ninguna firma y sin anestesista) de ese día, y solo si el
 * servidor ha dicho que la intervención no lleva anestesia. No se borra.
 */
export function ciDeAnestesiaQueNoSePide(ci, llevaAnestesia, { fecha, citaId } = {}) {
  if (llevaAnestesia !== false || !ci) return false;
  if (String(ci.template_code || '').trim().toLowerCase() !== 'anestesia') return false;
  if (!vacio(ci.patient_signature_b64) || !vacio(ci.doctor_signature_b64)
    || !vacio(ci.anesthetist_signature_b64) || ci.anesthetist_catalog_id) return false;
  const delDia = (fecha && String(ci.surgery_date || '').slice(0, 10) === fecha)
    || (citaId && ci.auto_generated_from_cita === citaId);
  return !!delDia;
}

/**
 * ¿Lleva anestesia lo que se ve en la hoja? Para el botón del FIN del
 * cirujano y el cuadro del CI en el diálogo «Firmas». Parte de lo que dijo el
 * servidor al abrir la hoja y suma lo que se acaba de hacer en pantalla y que
 * el servidor también cuenta para que la marca «local» deje de valer: firmar
 * la hoja, elegir su anestesista o adjuntar el CI de anestesia. Lo escrito
 * (sedación, anestésico) no decide nada, tampoco aquí.
 *
 * Con `sinSedacion` (el servidor dijo que no la lleva porque el registro
 * marca «¿Con sedación?» No) nada de eso la vuelve a pedir: el servidor
 * tampoco lo cuenta (8/10/2026). Lo que ya hubiera se enseña, no se exige.
 */
export function llevaAnestesiaEnPantalla(llevaAnestesia, { firma, hojaFirmante, ci, sinSedacion } = {}) {
  if (llevaAnestesia !== false) return true;
  if (sinSedacion) return false;
  return !!(firma || hojaFirmante?.anesthetist_name
    || ci?.anesthetist_catalog_id || !vacio(ci?.anesthetist_signature_b64));
}
